<template>
    <div>
        <table-tool-bar>
            <template slot="left">
            </template>
            <Button v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd">
                新增客户
            </Button>
        </table-tool-bar>
        <Table ref="mt" 
            :columns="columns" 
            :data="page.list" 
            :loading="loading" 
            :height="mtHeight">
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="rowClickInfo(row)">
                    详情
                </Button>
                <PoptipButton v-if="$can('delete')"
                    text="删除"
                    transfer
                    type="default"
                    title="您确定删除这条记录吗？"
                    :ok="() => { rowConfirmDelete(row) }">
                </PoptipButton>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch">
        </table-pager>
        <!-- 弹出层 -->
        <smart-modal v-model="modal.showCustomer"
            :title="curId ? '客户编辑' : '客户登记'"
            :width="800"
            :height="440"
            :maskClosable="false"
            :buttons.sync="formBtns"
            @close-by-confirm="search">
            <form-customer v-if="modal.showCustomer" :id="curId"></form-customer>
        </smart-modal>
    </div>
</template>
<script>
import { mapCell } from '_c/grid/renderCell'
import FormCustomer from './form-customer'
import { customerList, customerDelete } from '@/api/customer-manage'
import Dict from '_u/dict'

const PAGE_SIZE = 20

export default {
    name: 'ListCustomer',

    components: {
        FormCustomer
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE
            },
            page: {
                total: 0,
                list: []
            },
            dict: {
                customerNature: Dict.NULL,
                customerType: Dict.NULL
            },
            modal: {
                showCustomer: false
            },
            curId: '',
            formBtns: []
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'customerName',
                    title: '客户名称',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true
                },
                {
                    key: 'contactName',
                    title: '联系人',
                    align: 'left',
                    minWidth: 100
                },
                {
                    key: 'contactPhone',
                    title: '联系电话',
                    align: 'left',
                    minWidth: 100
                },
                {
                    key: 'customerNature',
                    title: '客户性质',
                    align: 'center',
                    minWidth: 120,
                    render: mapCell(this.dict.customerNature.val())
                },
                {
                    key: 'customerType',
                    title: '客户分类',
                    align: 'center',
                    width: 100,
                    render: mapCell(this.dict.customerType.val())
                },
                {
                    key: 'remark',
                    title: '说明',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 180,
                    fixed:"right",
                    slot: 'action'
                }
            ]
        }
    },

    watch: {},

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                Dict.get(['customer_nature', 'customer_type']),
                customerList(this.filter)
            ])
                .then(args => {
                    var [dictGroup, page] = args
                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        onClickAdd(e) {
            this.curId = ''
            this.modal.showCustomer = true
        },

        rowClickInfo(row) {
            this.curId = row.id
            this.modal.showCustomer = true
        },
        rowConfirmDelete(row) {
            this.loading = true
            customerDelete(row.id)
                .then(() => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        }
    }
}
</script>
<style lang="less" 
    scoped>
</style>